(() => { if (window.BEAEPAGEJS === undefined) {
            window.BEAEPAGEJS = [];
          }

          if(window.beaePageSetting == undefined) {
            window.beaePageSetting = {};
          }
          
          window.beaePageSetting.pageId = "68a6a6600c7f8f3d0a0d27f5";
              window.beaePageSetting.pageTitle = "footer"; 
              window.beaePageSetting.pageType = "footer";

          let js_1K221P7A = () => { let BeaeUseHooks = {};
      try {
        let argid = 'beae-0s7ab142section-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-0s7ab142',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-0s7ab142');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-0s7ab142: ', ex)
      };
    

      try {
        let argid = 'beae-riogg9f4linkslist-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-riogg9f4',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-riogg9f4');
        args.el = args.els[0];
        ((f) => { const b=f.el.querySelector(".beae-linkslist-title"),C=f.el.querySelector(".beae-linkslist");b===null||C===null||b.addEventListener("click",g=>{window.matchMedia("(max-width: 767px)").matches&&C.classList.toggle("open")}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-riogg9f4: ', ex)
      };
    

      try {
        let argid = 'beae-swqhy0oolinkslist-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-swqhy0oo',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-swqhy0oo');
        args.el = args.els[0];
        ((f) => { const b=f.el.querySelector(".beae-linkslist-title"),C=f.el.querySelector(".beae-linkslist");b===null||C===null||b.addEventListener("click",g=>{window.matchMedia("(max-width: 767px)").matches&&C.classList.toggle("open")}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-swqhy0oo: ', ex)
      };
    

      try {
        let argid = 'beae-d35n1y1oblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-d35n1y1o',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-d35n1y1o');
        args.el = args.els[0];
        ((P) => { var I;let H=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");H==null||H.forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let D=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(D)return D.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-d35n1y1o: ', ex)
      };
    

      try {
        let argid = 'beae-tutya5cyblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-tutya5cy',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-tutya5cy');
        args.el = args.els[0];
        ((P) => { var I;let H=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");H==null||H.forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let D=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(D)return D.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-tutya5cy: ', ex)
      };
    

      try {
        let argid = 'beae-u8xua7wgblock-image',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-u8xua7wg',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-u8xua7wg');
        args.el = args.els[0];
        ((M) => { var P;if(M.el){if(M.shape){const O=M.el.closest(".beae-slider-items");O&&!O.hasAttribute("data-svg")&&(O==null||O.closest(".beae-section").insertAdjacentHTML("beforeend",`
                            <svg width="0" height="0" style="height: 0px !important; width: 0px !important; opacity: 0 !important;">
                            <defs>
                                <clipPath id="shape-${M.id}" clipPathUnits="objectBoundingBox">
                                ${M.shape.clipPath}
                                </clipPath>
                            </defs>
                            </svg>
                        `),O.setAttribute("data-svg","true"))}let H=M.el.querySelector(".beae-image-content-position"),I,z=window.innerWidth>=768&&M.autoHover;var L=H.querySelector(".beae-img-ratio-control"),V=H.querySelector(".beae-img-comp-container"),T=H.querySelector(".beae-img-comp-container--second");if(L&&T){let O=function(A){let D=0,F;j(),z?H.onmouseover=function(G){W(G)}:A.onmousedown=function(G){W(G)},H.onmouseup=function(){q()},A.ontouchstart=function(G){W(G)},H.ontouchend=function(){q()};function j(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{I=T.offsetWidth})}).observe(T),A.style.left&&parseInt(A.style.left)}function W(G){check=!1,G.preventDefault(),G.clientX?G.clientX:G.touches[0].clientX,parseInt(A.style.left),D=1,H.onmousemove=function(X){R(X)},H.ontouchmove=function(X){R(X)}}function q(){D=0,check=!0}function R(G){if(D==0)return!1;F=U(G),F<0&&(F=0),F>100&&(F=100),Z(F)}function U(G){const X=H.getBoundingClientRect(),ie=(G.changedTouches?G.changedTouches[0].clientX:G.clientX)-X.left;return Math.max(0,Math.min(100,Math.round(ie*100/I)))}function Z(G){A.style.left=G+"%",T.style.clipPath=`polygon(${G}% 0%, ${G}% 100%, 100% 100%, 100% 0)`,V.style.clipPath=`polygon(0% 100%, 0% 0%, ${G}% 0%, ${G}% 100%)`}};L&&T&&O(L),window.addEventListener("resize",function(){L&&T&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{I=T.offsetWidth})}).observe(T),O(L))})}}let N=(P=M.el)==null?void 0:P.querySelector("a.beae-x-image"),E=N==null?void 0:N.getAttribute("href");N&&M.mode.value!=="builder"&&(E!=null&&E.includes("#"))&&N.addEventListener("click",H=>{let I=document.querySelector(E+","+(E==null?void 0:E.replace("#",".")));if(I)return I.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),H.preventDefault(),!1}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-u8xua7wg: ', ex)
      };
    

      try {
        let argid = 'beae-asaqi5v4lc-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-asaqi5v4',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-asaqi5v4');
        args.el = args.els[0];
        ((m) => { let h=m.checkLive;function p(v){return{input:v.querySelector('input[name="locale_code"], input[name="country_code"]'),button:v.querySelector("button.beae-current-value"),panel:v.querySelector(".beae-language-results"),search:v.querySelector('input[name="language_filter"]'),resetButton:v.querySelector(".beae-reset-button")}}function f(v,M){const L=m.el.querySelector("form.beae-localization");M.input.value=v.currentTarget.dataset.value,L&&L.submit()}function b(v){v.button.focus(),v.panel.classList.toggle("hidden-dropdown"),v.button.setAttribute("aria-expanded",(v.button.getAttribute("aria-expanded")==="false").toString());const M=v.button.getBoundingClientRect();window.innerHeight-M.bottom<v.panel.offsetHeight?(v.panel.style.top="auto",v.panel.style.bottom="100%"):(v.panel.style.top="100%",v.panel.style.bottom="auto")}function C(v){return v.normalize("NFD").replace(/\p{Diacritic}/gu,"").toLowerCase()}function g(v,M){const L=C(M.search.value),V=v.querySelectorAll(".beae-languages li");V.length,M.resetButton.classList.toggle("hidden",!L),V.forEach(T=>{C(T.querySelector(".beae-language-name").textContent).indexOf(L)>-1?T.classList.remove("beae-hidden"):T.classList.add("beae-hidden")})}function _(v){v.code.toUpperCase()==="ENTER"&&v.preventDefault()}function S(v,M,L){v.stopPropagation(),L.search.value="",g(M,L)}function B(v,M,L){(!M.contains(v.target)||!M.contains(v.relatedTarget))&&(k(M,L),L.button.setAttribute("aria-expanded",(L.button.getAttribute("aria-expanded")==="false").toString()))}function k(v,M){M.panel.classList.add("hidden-dropdown"),M.search&&(M.search.value="",g(v,M))}function $(v){const M=p(v);h&&v.addEventListener("focusout",L=>B(L,v,M)),M.button.addEventListener("click",()=>b(M)),v.querySelectorAll(".beae-language-name").forEach(L=>L.addEventListener("click",V=>f(V,M))),M.search&&(M.search.addEventListener("keyup",()=>g(v,M)),M.search.addEventListener("keydown",_)),M.resetButton&&(M.resetButton.addEventListener("click",L=>S(L,v,M)),M.resetButton.addEventListener("mousedown",L=>L.preventDefault()))}m.el.querySelectorAll(".beae-localization").forEach($) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-asaqi5v4: ', ex)
      };
    

      try {
        let argid = 'beae-86lv2wzelc-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-86lv2wze',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-86lv2wze');
        args.el = args.els[0];
        ((x) => { let m=x.checkLive;function h(w){return{input:w.querySelector('input[name="locale_code"], input[name="country_code"]'),button:w.querySelector("button.beae-current-value"),panel:w.querySelector(".beae-country-results"),search:w.querySelector('input[name="country_filter"]'),resetButton:w.querySelector(".beae-reset-button")}}function p(w,v){const M=x.el.querySelector("form.beae-localization");v.input.value=w.currentTarget.dataset.value,M&&M.submit()}function f(w){w.button.focus(),w.panel.classList.toggle("hidden-dropdown"),w.button.setAttribute("aria-expanded",(w.button.getAttribute("aria-expanded")==="false").toString());const v=w.button.getBoundingClientRect();window.innerHeight-v.bottom<w.panel.offsetHeight?(w.panel.style.top="auto",w.panel.style.bottom="100%"):(w.panel.style.top="100%",w.panel.style.bottom="auto")}function b(w){return w.normalize("NFD").replace(/\p{Diacritic}/gu,"").toLowerCase()}function C(w,v){const M=b(v.search.value),L=w.querySelectorAll(".beae-countries li");L.length,v.resetButton.classList.toggle("hidden",!M),L.forEach(V=>{b(V.querySelector(".beae-country-name").textContent).indexOf(M)>-1?V.classList.remove("beae-hidden"):V.classList.add("beae-hidden")})}function g(w){w.code.toUpperCase()==="ENTER"&&w.preventDefault()}function _(w,v,M){w.stopPropagation(),M.search.value="",C(v,M)}function S(w,v,M){(!v.contains(w.target)||!v.contains(w.relatedTarget))&&(B(v,M),M.button.setAttribute("aria-expanded",(M.button.getAttribute("aria-expanded")==="false").toString()))}function B(w,v){v.panel.classList.add("hidden-dropdown"),v.search&&(v.search.value="",C(w,v))}function k(w){const v=h(w);m&&w.addEventListener("focusout",M=>S(M,w,v)),v.button.addEventListener("click",()=>f(v)),w.querySelectorAll(".beae-country-name").forEach(M=>M.addEventListener("click",L=>p(L,v))),v.search&&(v.search.addEventListener("keyup",()=>C(w,v)),v.search.addEventListener("keydown",g)),v.resetButton&&(v.resetButton.addEventListener("click",M=>_(M,w,v)),v.resetButton.addEventListener("mousedown",M=>M.preventDefault()))}x.el.querySelectorAll(".beae-localization").forEach(k) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-86lv2wze: ', ex)
      };
    

      try {
        let argid = 'beae-4i1abii1block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-4i1abii1',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-4i1abii1');
        args.el = args.els[0];
        ((P) => { var I;let H=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");H==null||H.forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let D=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(D)return D.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-4i1abii1: ', ex)
      };
    

      try {
        let argid = 'beae-wh8kiqjfblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-wh8kiqjf',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-wh8kiqjf');
        args.el = args.els[0];
        ((P) => { var I;let H=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");H==null||H.forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let D=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(D)return D.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-wh8kiqjf: ', ex)
      };
    

      try {
        let argid = 'beae-8f0s08dusection-slide-show',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-8f0s08du',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-8f0s08du');
        args.el = args.els[0];
        ((h) => { window.BeaeSlider&&!h.noRunJs&&window.BeaeSlider(h) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-8f0s08du: ', ex)
      };
    }; if (window.BEAEBASE) {js_1K221P7A()} else {window.BEAEPAGEJS.push(js_1K221P7A)} })(); 